
export const animations = {
    pageTransition: {
      initial: { opacity: 0, x: -20 },
      animate: { opacity: 1, x: 0 },
      exit: { opacity: 0, x: 20 },
      transition: { duration: 0.3 }
    },
    
    mapInitial: { opacity: 0, scale: 0.95 },
    mapAnimate: { opacity: 1, scale: 1 },
    mapTransition: { delay: 0.2, duration: 0.3 },
    
    fadeIn: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: 0.2 }
    }
  };
  